import { render, staticRenderFns } from "./ProductGroups.vue?vue&type=template&id=ba0a09e8&"
import script from "./ProductGroups.vue?vue&type=script&lang=ts&"
export * from "./ProductGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports